﻿export const prefersReducedMotion = () => matchMedia("(prefers-reduced-motion)").matches;